import { Button } from 'antd'
import styled from 'styled-components'

const BaseButton = styled(Button)`
  border-radius: 6px;
`
export default BaseButton as any
